import React, {useState, useEffect} from 'react';

import ComboBox from "../../component/ComboBox";
import Typography from 'components/Typography';
import { Row, Col, Input, Card, CardHeader, CardBody, Modal, ModalHeader, ModalBody, Alert, FormGroup, Label, Button, ButtonGroup } from 'reactstrap';
import Resizer from "react-image-file-resizer";
import { Cookies } from 'react-cookie';

import DataAdapter from "../../adapter/DataAdapter";
import Base64 from 'Base64';

const cookie =new Cookies();
const _BACKEND_URL_ = "https://node.renobuilding.ca:3001"
const getToday=()=>{
	var today = new Date();
	return today.getFullYear() + '-' + (today.getMonth()<9 ? '0'+(today.getMonth()+1) : today.getMonth()+1) + '-' + today.getDate();
	
}

function FormReceiveAndPayment (props){
	const _FOLDER_	=	'Orders';
	var date = new Date();
	var _date = date.toISOString().split('T')[0];
	
    const [item, setItem] 				= useState([]);
    const [isOpen, setIsOpen] 			= useState(true);
	
    const [selectedFile, setSelectedFile] 			= useState(null);
    const [parent, setParent] 						= useState(null);
	
    const [uploading, setUploading] 	= useState(false);
    const [alert, setAlert] 			= useState('');
	
    const [accountOfId, setAccountOfId]			= useState(0);
    const [department, setDepartment]			= useState(0);
    const [boardType, setBoardType]				= useState(1);
    const [status, setStatus] 					= useState(9);
    const [prj_id, setPrj_id] 					= useState(0);
    const [prj_folder_id, setPrj_folder_id] 	= useState(0);
    const [prj_category_1, setPrj_category_1] 	= useState(0);
    const [rp_type, setRp_type] 				= useState(2);
    const [pt_id, setPt_id] 					= useState(0);
    const [ptd_id, setPtd_id] 					= useState(0);
    const [service_id, setService_id] 			= useState(0);
    const [task_type, setTask_type]				= useState(-1);
    const [rp_cat, setRp_cat] 					= useState(0);
    const [bank_id, setBank_id] 				= useState(0);
    const [rp_method, setRp_method] 			= useState(0);
    const [rp_date, setRp_date] 				= useState(_date);
    const [rp_amount, setRp_amount] 			= useState(0);
    const [rp_desc, setRp_desc] 				= useState('');
    const [is_done, setIs_done] 				= useState(true);
    const [order_no, setOrder_no] 				= useState(0);
    const [image_id, setImage_id] 				= useState(0);
    const [user_type, setUser_type]				= useState(-1);
    const [person_id, setPerson_id] 			= useState(-1);
    const [check_date, setCheck_date] 			= useState(0);
    const [image, setImage] 					= useState(null);

	useEffect(()=>{
		document.title="Receive And Payment";				
	},[]);

	useEffect(()=>{
		var _project	= props.project;
		var _date 		= getToday();
		if(_project){
			//setRp_date(_date);
			setPrj_id(_project.prj_id);
			setPt_id(_project.pt_id);
			setService_id(_project.task_no);
			setPrj_folder_id(_project.prj_folder_id);
			setPrj_category_1(_project.prj_category_1);
			findParent(_FOLDER_, _project.prj_folder_id);
		}
				
	},[props]);
	const findParent = (_destinationFolder, _parent) => {
				setUploading(true);
				setAlert('');
				setParent(null);
				let requestOptions = {
					method: 'GET',
					headers: {
						'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
					}
				};
				fetch(_BACKEND_URL_ + '/search?fullText=' + _destinationFolder + '&parent=' + _parent + '&mimeType=application/vnd.google-apps.folder', requestOptions)
				.then(response => {
				  return Promise.all([response.json(),response])
				})
				.then(([responseData,response]) => {
					setParent(responseData[0].id);
					setUploading(false);
				})
				.catch(error => {
					console.error('Error:', error);
				})			
	}
	const onFieldChangeHandler=(event)=>{
		event.persist();
		
		if(event.target.id === 'prj_department')
			setDepartment(event.target.value);
		
		if(event.target.id === 'prj_status')
			setStatus(event.target.value);
		
		if(event.target.id === 'prj_id'){
			setPrj_id(event.target.value.split(',')[0]);
			setPrj_folder_id(event.target.value.split(',')[1]);
			setPrj_category_1(event.target.value.split(',')[2]);
			if(event.target.value.split(',')[1]!=0){
				findParent(_FOLDER_, event.target.value.split(',')[1]);
			}else{
				setAlert('');
				setParent(null);
			}
		}
		if(event.target.id === 'pt_id'){
			setPt_id(event.target.value.split(',')[0]);
			setService_id(event.target.value.split(',')[1]);
			setTask_type(event.target.value.split(',')[2]);
			
			var dataAdapter =new DataAdapter("SELECT rb_types.rb_type_no, rb_types.rb_type_desc, rb_types.rb_type_type_no FROM rb_types WHERE rb_types.rb_type_no = " + event.target.value.split(',')[2] + " AND rb_types.rb_type_id=11");
				dataAdapter.getRecords().then(data=>{
					setRp_cat(data[0].rb_type_type_no);
				})
		}			
		if(event.target.id === 'rp_date')
			setRp_date(event.target.value);
		if(event.target.id === 'service_id'){
			setService_id(event.target.value);
			setRp_cat(event.target[event.target.selectedIndex].attributes["attribute"].nodeValue);
		}
		if(event.target.id === 'amount')
			setRp_amount(event.target.value);
		if(event.target.id === 'rp_desc')
			setRp_desc(event.target.value);
		if(event.target.id === 'rp_type')
			setRp_type(event.target.value);
		if(event.target.id === 'rp_cat')
			setRp_cat(event.target.value);
		if(event.target.id === 'rb_types-rb_type_id-5')
			setBank_id(event.target.value);
		if(event.target.id === 'rb_types-rb_type-rp_method')
			setRp_method(event.target.value);
		
		if(event.target.id === 'user_type')
			setUser_type(event.target.value);
		if(event.target.id === 'person_id')
			setPerson_id(event.target.value);
	}


	const onSubmitHandler=(event)=>{
		// Build formData object.
		setUploading(true);
		let formData = new FormData();

		formData.append('prj_id', prj_id);
		formData.append('ptd_id', ptd_id);
		formData.append('pt_id', pt_id);
		formData.append('rp_date', rp_date);
		formData.append('person_id', person_id);
		formData.append('amount', rp_amount);
		formData.append('bank_id', bank_id);
		formData.append('order_no', order_no);
		formData.append('rp_desc', rp_desc);
		formData.append('image_id', image_id);
		formData.append('rp_type', rp_type);
		formData.append('rp_cat', rp_cat);
		formData.append('user_id', cookie.get("v-person-id"));
		formData.append('rp_method', rp_method);
		formData.append('check_date', check_date);
		formData.append('is_done', is_done);
		formData.append('prj_department', department);
		formData.append('account_of_id', accountOfId);


		fetch("https://renobuilding.ca/wp-json/reno/v1/rb_receive_n_payments",
			{
				method: "POST",
				headers: {
					'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
				},
				body: formData
			})
			.then(response => {
				//console.log(response);
				setUploading(false);
				setIsOpen(false);
				//this.addNotification('New record has been created.');
				
				return Promise.all([response.json(),response])
			  })
			  .catch(error => {
				  console.error('Error:', error);
			  })		
  
	}
	const onFileChange = async (event) => {
			setSelectedFile(event.target.files);
		if(parent){
			setUploading(true);
			const image = await resizeFile(event.target.files[0]);
			
			const formData = new FormData()
			formData.append('myfile', image);
		
			fetch(_BACKEND_URL_ + '/file?project=' + parent, {
			method: 'POST',
			body: formData
			})
			.then(response => response.json())
			.then(data => {
				setImage_id(data.data.id);
				setUploading(false);
				//this.addNotification('Image has been uploaded');
			})
			.catch(error => {
				console.error(error)
			});
		}else{
			setAlert(' Select Project!');
		}
	}; 
	const imageUpload =(files) =>{
		for(var i=0; i < files.length ; i++){
			const formData = new FormData()
			formData.append('myfile', files[i]);
		
			fetch(_BACKEND_URL_ + '/file?project=' + parent, {
			method: 'POST',
			body: formData
			})
			.then(response => response.json())
			.then(data => {
				setImage_id(data.data.id);
				setUploading(false);
				//this.addNotification('Image has been uploaded');
			})
			.catch(error => {
			console.error(error)
			});
		}
	}
	const resizeFile = (file) => new Promise(resolve => {
		Resizer.imageFileResizer(file, 640, 480, 'JPEG', 100, 0,
		uri => {
		  resolve(uri);
		}, 'file' );
	});

	const handlePaste = (event) => {
		const items = event.clipboardData.items;
		for (let item of items) {
			if (item.type.indexOf("image") === 0) {
				const blob = item.getAsFile();
				const reader = new FileReader();
				
				reader.onload = () => {
					setImage(reader.result); // Store base64 image in state
				};
	
				reader.readAsDataURL(blob); // Convert image to base64
			}
		}
	};
		

	
	return (
		<>
				<div onPaste={handlePaste} >
					<Row>
						<Col md={12} sm={12} xs={12} >
							<Card>
								<CardHeader>New {rp_type == 1? "Receive" : "Payment"} </CardHeader>
								<CardBody>
								{image && (
									<div>
										<img src={image} alt="Compressed Preview" style={{ height: "100px", border:'1px solid' }} />
									</div>
								)}
								{uploading?
									  <Alert color="info">
										<Typography type="h4" className="alert-heading">
										  Please wait ...
										</Typography>
									 </Alert>
								:''}
								<form style={{display:'none'}} >
									<div className="mb-3">
										<label htmlFor="formFile">
											<i className="btn btn-outline-secondary btn-sm" >Take Photo from Camera</i>
											<input className="form-control" style={{display: 'none'}}  type="file" id="formFile" onChange={onFileChange} accept="image/*" capture="capture"  data-original-title="upload photos" />
										</label>
										{'    '}
										<label htmlFor="formFileMultiple">
											<i className="btn btn-outline-secondary btn-sm" >Select from Gallery</i>
											<input className="form-control" style={{display: 'none'}}  type="file" id="formFileMultiple" onChange={onFileChange} accept="image/*" multiple data-original-title="upload photos" />
										</label>
									</div>
								</form>
									<FormGroup row className="d-block" >
										<Label for="person_name" md={3} ></Label>
										<Col md={9}>
											<div className="form-check form-check-inline">
												{rp_type==1?  
													<input className="form-check-input" type="radio" name="rp_type" id="rp_type" value="1" checked  onChange={onFieldChangeHandler} />
												: 
													<input className="form-check-input" type="radio" name="rp_type" id="rp_type" value="1"  onChange={onFieldChangeHandler} />
												}
												<label className="form-check-label" for="rp_type">Receive</label>
											</div>
											<div className="form-check form-check-inline">
											{rp_type==2?  
													<input className="form-check-input" type="radio" name="rp_type" id="rp_type" value="2" checked onChange={onFieldChangeHandler} />
												: 
													<input className="form-check-input" type="radio" name="rp_type" id="rp_type" value="2" onChange={onFieldChangeHandler} />
												}
												<label className="form-check-label" for="rp_type">Payment</label>
											</div>
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="rp_date" md={3}> Date</Label>
										<Col md={9} >
											<Input
												type="date"
												name="rp_date"
												id="rp_date"
												defaultValue={rp_date}
												onChange={onFieldChangeHandler}
											/>
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="prj_status" md={3} >Status</Label>
										<Col md={9}>
											<ComboBox id="prj_status" onChange={onFieldChangeHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"prj_status"} orderby="rb_type_no"  defaultValue={status} />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={3} >Project</Label>
										<Col md={2}>
											<ButtonGroup className="mr-3 mb-3">
												<Button color={boardType==0?"primary":"light"} onClick={(e)=>{setBoardType(0);}} >Internal</Button>
												<Button color={boardType==1?"primary":"light"} onClick={(e)=>{setBoardType(1);}} >External</Button>
											</ButtonGroup>
										</Col>
										<Col md={7}>
											{boardType==0?
											<ComboBox id="prj_id" onChange={onFieldChangeHandler}  table="rb_projects" valueField="prj_id,prj_folder_id,prj_category_1" displayField="prj_code,prj_title" filterField="prj_status" filterValue={"23' AND prj_code IN (SELECT distinct rb_type_caption FROM rb_types WHERE rb_type='task_type' AND rb_type_caption <> '') AND 'x'='x"} orderby="prj_code"  defaultValue={prj_id + ',' + prj_folder_id + ',' + prj_category_1} onCallback={()=>{}}/>
											:
											<ComboBox id="prj_id" onChange={onFieldChangeHandler}  table="rb_projects" valueField="prj_id,prj_folder_id,prj_category_1" displayField="prj_code,prj_title" filterField="prj_status" filterValue={status} orderby="prj_id DESC"  defaultValue={prj_id + ',' + prj_folder_id + ',' + prj_category_1} onCallback={()=>{}}/>
											}
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="account_of_id" md={3} >Account of</Label>
										<Col md={9}>
											<ComboBox id="account_of_id" onChange={onFieldChangeHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"prj_department' AND (rb_type_type_no>0 OR rb_type_type_no=-1) AND 'x'='x"} orderby="rb_type_desc"  defaultValue={accountOfId} onCallback={()=>{}}/>
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={3} >Task</Label>
										<Col md={9}>
											{boardType==0?
												<ComboBox id="pt_id" onChange={onFieldChangeHandler}  table="rb_project_tasks" valueField="pt_id,task_no,task_type" displayField="item_no,task" filterField="prj_id" filterValue={prj_id + "' AND task_type IN (120,121,122,123,124,125,126,127,128) AND 'x'='x"} orderby="item_no" defaultValue={pt_id + ',' + service_id + ',' + task_type } />
											:
												<ComboBox id="pt_id" onChange={onFieldChangeHandler}  table="rb_project_tasks" valueField="pt_id,task_no,task_type" displayField="item_no,task" filterField="prj_id" filterValue={prj_id + "' AND parent IS NOT NULL AND sort_id<>0 AND task_type <> 122 AND task_status IN (9,10) AND 'x'='x"} orderby="item_no" defaultValue={pt_id + ',' + service_id + ',' + task_type } />
											}
											{parent? <Alert color="info">Destination Folder ({_FOLDER_}) Founded </Alert>:''}
											{alert?<Alert color="info">{alert}</Alert>:''}
										</Col>
									</FormGroup>
									<FormGroup className="d-none" row >
										<Label for="person_name" md={3} >Service</Label>
										<Col md={9}>
											<ComboBox id="service_id" table="rb_services" valueField="service_id" attribute="service_type" displayField="service_item" filterField="category_id" filterValue={prj_category_1 + "' AND 'x'='x" } onChange={onFieldChangeHandler} defaultValue={service_id} orderby="service_item" />
										</Col>
									</FormGroup>
									<FormGroup className="d-none-" row >
										<Label for="person_name" md={3} >Category</Label>
										<Col md={9}>
											<ComboBox id="rp_cat" table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"rp_cat' " + (task_type!=-1?" AND rb_type_type_no='" + task_type: " AND 'x'='x")} onChange={onFieldChangeHandler} defaultValue={rp_cat} orderby="rb_type_desc" />
										</Col>
									</FormGroup>									
									<FormGroup row >
										<Label for="prj_department" md={3} >{rp_type == 1? "Receive To" : "Pay From"}</Label>
										<Col md={9}>
											<ComboBox id="prj_department" onChange={onFieldChangeHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"prj_department' AND (rb_type_type_no>0 OR rb_type_type_no=-1) AND 'x'='x"} orderby="rb_type_desc"  defaultValue={department} onCallback={()=>{}}/>
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={3} >Bank</Label>
										<Col md={9}>
											<ComboBox table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type_id" filterValue={"5' AND rb_type_type_no = " + department + " AND 'x'='x"} onChange={onFieldChangeHandler} orderby="rb_type_desc" />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={3} >Method</Label>
										<Col md={9}>
											<ComboBox table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="rp_method" onChange={onFieldChangeHandler} orderby="rb_type_desc" />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="amount" md={3} >Amount</Label>
										<Col md={9}>
											<Input type="text" name="amount" id="amount" onChange={onFieldChangeHandler} value={rp_amount} />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="rp_desc" md={3} >Descrption</Label>
										<Col md={9}>
											<Input type="text" name="rp_desc" id="rp_desc" onChange={onFieldChangeHandler} value={rp_desc} />
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="person_name" md={3} >{rp_type == 1? "Sender" : "Receiver"} Type</Label>
										<Col md={3}>
											<ComboBox id="user_type" onChange={onFieldChangeHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"person_type"} orderby="rb_type_desc" defaultValue={user_type } />
										</Col>
										<Label for="person_name" md={2} >{rp_type == 1? "Sender" : "Receiver"}</Label>
										<Col md={4}>
											<ComboBox id="person_id" onChange={onFieldChangeHandler}  table="rb_person" valueField="person_id" displayField="name,lastname,email" filterField="person_type" filterValue={user_type} orderby="name" defaultValue={person_id } />
										</Col>
									</FormGroup>
									<FormGroup check row>
										<Col>
											<Button className="float-right" onClick={onSubmitHandler} >Submit</Button>
										</Col>
									</FormGroup>
									<FormGroup row >
										<Label for="is_done" md={3} >Is Done</Label>
										<Col md={9}>
											<Input type="checkbox" name="is_done" id="is_done" onChange={(e)=>{setIs_done(e.target.checked);}} checked={is_done} />
										</Col>
									</FormGroup>
								</CardBody>
							</Card>
						</Col>
					</Row>
			</div>							
		</>
	);
}

export default FormReceiveAndPayment;